export default __webpack_public_path__ + "static/media/coffee-beans-ground-coffee-and-instant-coffee-in-2021-07-19-16-56-44-utc.af2b2237.svg";